import { setSocket } from "../../redux/admin-slices/socket.slice"
import { getAdminProfileReq } from "../../redux/admin-slices/auth.slice"
import { Outlet, useLocation } from "react-router-dom"
import DialogContainer from "../../components/Dialog"
import { SOCKET_BASEURI } from "../../utils/helper"
import { useEffect, useRef, useState } from "react"
import Toaster from "../../components/ui/Toaster"
import { useDispatch } from "react-redux"
import { io } from "socket.io-client"
import { Box } from "@mui/material"
import Sidebar from "./Sidebar"
import Header from "./Header"

function Layout() {
  const socket = useRef(null)
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const [active, setActive] = useState(false)

  const sidebarActive = () => { setActive(true) }
  const sidebarDeActive = () => { setActive(false) }
  const toggleSidebar = () => { setActive(!active) }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [pathname])

  useEffect(() => {
    dispatch(getAdminProfileReq())
  }, [dispatch])

  useEffect(() => {
    // socket.current = null
    socket.current = io.connect(SOCKET_BASEURI)
    if (!socket.current) return;
    dispatch(setSocket(socket.current))
    // eslint-disable-next-line
  }, [socket.current]);

  return (
    <Box
      className={active ? "activeSidebar" : ""}
      sx={{
        "& aside": {
          left: { xs: "-100%", laptop: "0" }
        },
        "&.activeSidebar aside": {
          left: { xs: "0", laptop: "-100%" }
        },
        "&.activeSidebar .mainContent": { ml: "0" },
      }}
    >
      <Sidebar
        active={active}
        sidebarActive={sidebarActive}
        sidebarDeActive={sidebarDeActive}
      />
      <Box
        sx={{
          display: "grid",
          minHeight: "calc(100vh + 1px)",
          gridTemplateRows: "auto 1fr",
          transition: "all 350ms ease",
          ml: { xs: "0", laptop: "300px" },
          maxWidth: {
            xs: "calc(100vw - 16px)",
            laptop: active ? "calc(100vw - 16px)" : "calc(100vw - 316px)",
          },
        }}
        className="mainContent"
      >
        <Header
          toggleSidebar={toggleSidebar}
        />
        <Box
          component="main"
          sx={{
            maxWidth: {
              xs: "calc(100vw - 16px)",
              laptop: active ? "calc(100vw - 16px)" : "calc(100vw - 316px)",
            }
          }}
        >
          <Outlet context={{ active }} />
        </Box>
      </Box>
      <Toaster />
      <DialogContainer />
    </Box>
  )
}

export default Layout